import React from 'react'
import './css/termsModal.css'

function TermsAndConditionsModal({ onClose }) {
  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>BuzzTickets Terms and Conditions</h2>
          <button className="terms-modal-close" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <div className="terms-modal-body">
          <p className="terms-effective-date">Effective Date: July 2, 2026</p>

          <p>
            Welcome to BuzzTickets, an online event management and ticketing platform owned,
            operated, and maintained by SmartBuilders (Pty) Ltd ("SmartBuilders", "we", "our", or
            "us"). By creating an account, accessing, or using the BuzzTickets platform, you
            acknowledge that you have read, understood, and agree to be bound by these Terms and
            Conditions. If you do not agree with these Terms, you must not create an account or use
            the platform.
          </p>

          <h3>1. About BuzzTickets</h3>
          <p>
            BuzzTickets is an online event management and ticketing platform that enables event
            organizers to create, promote, manage, and sell tickets for their events.
          </p>
          <p>
            BuzzTickets is a software platform developed, owned, and operated by SmartBuilders (Pty)
            Ltd. BuzzTickets acts solely as a technology platform connecting event organizers with
            customers. Neither BuzzTickets nor SmartBuilders (Pty) Ltd is the organizer, promoter,
            sponsor, venue owner, or operator of any event listed on the platform unless expressly
            stated otherwise.
          </p>

          <h3>2. Eligibility</h3>
          <p>By creating an account, you confirm that:</p>
          <ul>
            <li>You are at least 18 years of age or have permission from a parent or legal guardian.</li>
            <li>All information you provide is accurate and up to date.</li>
            <li>You will keep your account credentials secure.</li>
            <li>You are responsible for all activity conducted through your account.</li>
          </ul>

          <h3>3. Event Organizers</h3>
          <p>If you create or host an event on BuzzTickets, you agree that you:</p>
          <ul>
            <li>Are legally authorized to organize and host the event.</li>
            <li>Will provide accurate and truthful event information.</li>
            <li>Will comply with all applicable South African laws and regulations.</li>
            <li>
              Are solely responsible for obtaining all permits, licences, insurance, approvals, and
              permissions required for your event.
            </li>
            <li>
              Are solely responsible for the safety, operation, staffing, and management of your
              event.
            </li>
            <li>Will honour all valid tickets sold through BuzzTickets.</li>
            <li>Will communicate any event changes to attendees promptly.</li>
          </ul>
          <p>
            SmartBuilders (Pty) Ltd reserves the right to remove, suspend, or disable any event that
            violates these Terms, applicable law, or may expose the platform to legal or reputational
            risk.
          </p>

          <h3>4. Ticket Purchases</h3>
          <p>When purchasing tickets through BuzzTickets, you acknowledge and agree that:</p>
          <ul>
            <li>
              You are purchasing tickets from the event organizer and not from BuzzTickets or
              SmartBuilders (Pty) Ltd.
            </li>
            <li>Your purchase forms a contract between you and the event organizer.</li>
            <li>Ticket availability is determined by the organizer.</li>
            <li>Prices are determined by the organizer.</li>
            <li>Tickets may not be resold where prohibited by law or the organizer's policies.</li>
          </ul>

          <h3>5. Service Fees</h3>
          <p>By purchasing a ticket through BuzzTickets, you acknowledge and agree that:</p>
          <ul>
            <li>
              A BuzzTickets Service Fee of 3% + R1 per ticket will be added to your purchase where
              applicable.
            </li>
            <li>This service fee is non-refundable except where required by applicable law.</li>
            <li>Additional payment processing fees charged by PayStack applies during checkout.</li>
            <li>
              These processing fees are determined solely by the payment provider and are outside the
              control of BuzzTickets and SmartBuilders (Pty) Ltd.
            </li>
          </ul>
          <p>By completing your purchase, you expressly agree to these fees.</p>

          <h3>6. Organizer Commission</h3>
          <p>Event organizers agree that:</p>
          <ul>
            <li>BuzzTickets charges a commission of 2% of total ticket sales.</li>
            <li>Commission will be deducted before settlement unless otherwise agreed in writing.</li>
            <li>
              BuzzTickets facilitates ticket sales but does not hold or retain ticket sale proceeds on
              behalf of Event Organizers. Payments made by customers are securely processed through
              PayStack and are settled directly to the Event Organizer in accordance with PayStack's
              settlement processes. SmartBuilders (Pty) Ltd does not have custody or control of these
              funds, except that the agreed BuzzTickets commission, as set out in these Terms and
              Conditions, is deducted where applicable.
            </li>
          </ul>

          <h3>7. Refund Policy</h3>
          <p>BuzzTickets and SmartBuilders (Pty) Ltd do not issue or process refunds.</p>
          <p>All refund requests must be directed to the event organizer.</p>
          <p>
            The organizer is solely responsible for determining whether refunds will be granted,
            including in cases involving:
          </p>
          <ul>
            <li>Event cancellation</li>
            <li>Event postponement</li>
            <li>Venue changes</li>
            <li>Artist or speaker changes</li>
            <li>Customer cancellations</li>
            <li>Any other event-related circumstances</li>
          </ul>
          <p>
            BuzzTickets and SmartBuilders (Pty) Ltd are not responsible for refund decisions made by
            event organizers. Where appropriate, BuzzTickets may facilitate communication between
            organizers and customers but accepts no responsibility or liability for refund outcomes.
          </p>

          <h3>8. Event Changes or Cancellations</h3>
          <p>BuzzTickets and SmartBuilders (Pty) Ltd are not responsible for:</p>
          <ul>
            <li>Event cancellations</li>
            <li>Event postponements</li>
            <li>Venue changes</li>
            <li>Schedule changes</li>
            <li>Performer substitutions</li>
            <li>Capacity limitations</li>
            <li>Event quality</li>
            <li>Admission decisions made by organizers</li>
          </ul>
          <p>These matters are entirely the responsibility of the event organizer.</p>

          <h3>9. Limitation of Liability</h3>
          <p>
            To the fullest extent permitted by South African law, BuzzTickets and SmartBuilders (Pty)
            Ltd shall not be liable for any:
          </p>
          <ul>
            <li>Event cancellations</li>
            <li>Event postponements</li>
            <li>Financial losses</li>
            <li>Travel costs</li>
            <li>Accommodation expenses</li>
            <li>Personal injury or death</li>
            <li>Property damage</li>
            <li>Lost profits</li>
            <li>Missed business opportunities</li>
            <li>
              Indirect, incidental, special, or consequential damages arising from attendance or
              non-attendance at any event.
            </li>
          </ul>
          <p>
            BuzzTickets merely provides the technology platform used by independent event organizers
            to list events and facilitate ticket sales.
          </p>

          <h3>10. Payment Processing</h3>
          <p>Payments are securely processed by PayStack.</p>
          <p>
            Neither BuzzTickets nor SmartBuilders (Pty) Ltd stores customers' debit or credit card
            information.
          </p>
          <p>
            Customers acknowledge that payment processing is subject to the terms, conditions, privacy
            policies, and security measures of the payment provider.
          </p>

          <h3>11. Prohibited Activities</h3>
          <p>Users may not:</p>
          <ul>
            <li>Sell fraudulent or counterfeit tickets.</li>
            <li>Create fake or misleading events.</li>
            <li>Use the platform for unlawful purposes.</li>
            <li>Attempt to gain unauthorized access to BuzzTickets systems.</li>
            <li>Interfere with platform operations.</li>
            <li>Upload malicious software or code.</li>
            <li>Engage in fraudulent or deceptive transactions.</li>
            <li>Misrepresent themselves or their events.</li>
          </ul>
          <p>
            Violation of these Terms may result in immediate suspension or permanent termination of
            your account.
          </p>

          <h3>12. Intellectual Property</h3>
          <p>
            All BuzzTickets branding, logos, software, source code, designs, graphics, content,
            documentation, and technology are the exclusive intellectual property of SmartBuilders
            (Pty) Ltd, unless otherwise stated.
          </p>
          <p>
            Users may not copy, reproduce, modify, distribute, reverse engineer, sublicense, or
            commercially exploit any part of the platform without prior written permission from
            SmartBuilders (Pty) Ltd.
          </p>

          <h3>13. Account Suspension</h3>
          <p>
            SmartBuilders (Pty) Ltd reserves the right to suspend, restrict, or permanently terminate
            accounts that:
          </p>
          <ul>
            <li>Violate these Terms.</li>
            <li>Engage in fraudulent activity.</li>
            <li>Misuse the platform.</li>
            <li>Harm other users.</li>
            <li>
              Create legal, financial, operational, or reputational risk to BuzzTickets or
              SmartBuilders (Pty) Ltd.
            </li>
          </ul>
          <p>
            Suspension or termination may occur without prior notice where necessary to protect the
            platform or comply with legal obligations.
          </p>

          <h3>14. Privacy</h3>
          <p>Your use of BuzzTickets is also governed by the BuzzTickets Privacy Policy.</p>
          <p>
            By creating an account, you consent to the collection, processing, storage, and use of
            your personal information by SmartBuilders (Pty) Ltd in accordance with applicable South
            African privacy legislation, including the Protection of Personal Information Act, 2013
            (POPIA).
          </p>

          <h3>15. Indemnity</h3>
          <p>
            Event organizers agree to indemnify, defend, and hold harmless BuzzTickets, SmartBuilders
            (Pty) Ltd, its directors, officers, employees, contractors, affiliates, and agents against
            any claims, losses, liabilities, damages, costs, or legal expenses arising from:
          </p>
          <ul>
            <li>Their events.</li>
            <li>Their negligence.</li>
            <li>Breach of these Terms.</li>
            <li>Violation of any law.</li>
            <li>Claims made by attendees or third parties.</li>
          </ul>

          <h3>16. Force Majeure</h3>
          <p>
            Neither BuzzTickets nor SmartBuilders (Pty) Ltd shall be liable for delays or failures
            resulting from events beyond their reasonable control, including but not limited to:
          </p>
          <ul>
            <li>Natural disasters</li>
            <li>Government actions</li>
            <li>Internet outages</li>
            <li>Cyberattacks</li>
            <li>Power failures</li>
            <li>Labour disputes</li>
            <li>Pandemics</li>
            <li>Civil unrest</li>
            <li>Telecommunications failures</li>
          </ul>

          <h3>17. Changes to These Terms</h3>
          <p>SmartBuilders (Pty) Ltd may amend or update these Terms and Conditions from time to time.</p>
          <p>Updated versions will be published on the BuzzTickets platform.</p>
          <p>
            Continued use of the platform after changes become effective constitutes acceptance of the
            revised Terms.
          </p>

          <h3>18. Governing Law</h3>
          <p>
            These Terms shall be governed by and interpreted in accordance with the laws of the
            Republic of South Africa.
          </p>
          <p>
            Any dispute arising from these Terms or the use of the BuzzTickets platform shall be
            subject to the exclusive jurisdiction of the courts of South Africa.
          </p>

          <h3>19. Contact Information</h3>
          <p>For questions regarding these Terms and Conditions, please contact:</p>
          <p>
            SmartBuilders (Pty) Ltd
            <br />
            Email: <a href="mailto:info@smart-builders.co.za">info@smart-builders.co.za</a>
          </p>

          <h3>20. Acceptance</h3>
          <p>By creating a BuzzTickets account, you confirm that:</p>
          <ul>
            <li>You have read and understood these Terms and Conditions.</li>
            <li>You agree to comply with them.</li>
            <li>
              You understand that BuzzTickets is solely a technology platform owned and operated by
              SmartBuilders (Pty) Ltd and is not responsible for organizing, operating, managing, or
              administering events hosted by independent event organizers.
            </li>
            <li>
              You understand that all refunds, event-related disputes, cancellations, customer
              service, and event fulfilment remain the sole responsibility of the relevant event
              organizer.
            </li>
            <li>
              You agree to the applicable BuzzTickets Service Fee (3% + R1 per ticket) when purchasing
              tickets.
            </li>
            <li>
              You acknowledge that additional transaction or payment processing fees charged by
              PayStack may apply at checkout.
            </li>
            <li>
              You acknowledge that your continued use of BuzzTickets constitutes acceptance of these
              Terms and Conditions.
            </li>
          </ul>
        </div>

        <div className="terms-modal-footer">
          <button className="terms-modal-accept" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditionsModal
